import api from "../../utils/apiPublic";

export const obtenerSubcategoriasPublic = async () => {
  const res = await api.get("/api/public/subcategorias");
  const d = res.data;
  if (Array.isArray(d)) return d;
  if (d?.subcategorias && Array.isArray(d.subcategorias)) return d.subcategorias;
  return [];
};
